/**
 * `isSent` is set whatever the API answered, because the API answers the same way whether or not the
 * address is registered. A screen that distinguished the two would leak what the endpoint refuses to.
 */
export type ForgotPasswordState = {
  email: string;
  isSubmitting: boolean;
  isSent: boolean;
  error: string | null;
};

export const canSubmit = (state: ForgotPasswordState): boolean =>
  !state.isSubmitting && state.email.trim().length > 0;
